import styled from "styled-components";

import { colors } from "shared/ui";

export const Container = styled.div`
    max-width: 1128px;
    padding-bottom: 28px;
`;

export const Placeholder = styled.div`
    padding: 32px 8px;
    text-align: center;
    color: ${colors.textSecondary};
`;
